import { InjectionToken } from '@angular/core';

import type { PaletteConfig } from '../../../../models/palette.model';
import type {
	PaletteSaveNewPayload,
	PaletteSaveNewResult,
} from '../palette-tab/palette-save.types';

/** Host-provided palette list/create for the chart editor (Jepto app GraphQL). */
export interface ChartEditorPaletteHost {
	listPalettes(clientId: string | null): Promise<PaletteConfig[]>;
	createPalette(payload: PaletteSaveNewPayload): Promise<PaletteSaveNewResult>;
}

export const CHART_EDITOR_PALETTE_HOST = new InjectionToken<ChartEditorPaletteHost>(
	'CHART_EDITOR_PALETTE_HOST'
);
